import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'copetency-completion-score',
    components: {

    },
})

export default class CMCompletionScore extends Vue {

    // -----------------------------------------------------------------------
    // Properties
    @Prop()
    private selectedConfig: any;

    @Prop()
    private tenantSettings: any;

    @Prop()
    private defaultMinScore: any;

    private updateConfig: any = {};

    private categoryList: any = [];

    private selectedCategory: any = null;

    private defaultInputValue: any;

    private isShowSubject: boolean = false;

    // -----------------------------------------------------------------------------------
    // Hooks

    private mounted() {
        this.defaultInputValue = this.defaultMinScore;
        this.fetchCategoryLists();
    }

    // -----------------------------------------------------------------------------------
    // Actions

    private onSelectConfig(selectedCategory: any) {
        this.$emit('onChangeConfig', this.updateConfig);
    }

    private onSelectCategory(category: any) {
        this.selectedCategory = category;
        this.subjectLists(category);
    }

    private onSelectSubject(event: any, subject: any, index: any) {
        const childElement: any = (event.target.parentElement as HTMLElement).querySelector('.framework-blk');
        this.$el.querySelectorAll('.framework-blk').forEach((element, queryindex) => {
            if (element !== event) {
                if (queryindex === index) {
                    if ((element as HTMLElement).style.display === 'none' || (element as HTMLElement).style.display === '') {
                        (element as HTMLElement).style.display = 'block';
                    } else {
                        (element as HTMLElement).style.display = 'none';
                    }
                } else {
                    (element as HTMLElement).style.display = 'none';
                }
            }
        });
    }


    // ---------------------------------------------------------------------------------
    // Methods

    private subjectLists(category: any) {
        taxonomyAPI.fetchSubjects(category.id).then((subjects) => {
            this.$set(this.selectedCategory, 'subjectList', subjects);
            // this.selectedCategory.subjectList = subjects;
        });
    }

    private fetchCategoryLists() {
        taxonomyAPI.fetchTaxonomyClassifications().then((classification: any) => {
            this.categoryList = classification;
        });
    }

    // private parseConfig() {
    //     let framework = this.levels.find((item: any) => item.name === 'frameworks').selectedContent;
    //     let subject = this.levels.find((item: any) => item.name === 'subjects').selectedContent;
    //     return (this.selectedConfig.tenantConfig.value || {}, {
    //         [framework.code+'.'+subject.code]: 0
    //     })
    // }

    // private activeSubjectCode() {
    //     let subject = this.levels.find((item: any) => item.name === 'subjects').selectedContent;
    //     return subject.code;
    // }
}
